<div class="view-container">
  @if (showMobileView === false) {
    <!-- general -->
    @if (vehicles?.length) {
      <div
        class="content-container"
        id="general"
        [hidden]="currentTab !== 'vehicleGeneral'"
        >
        <div class="grid grid-cols-1 lg:grid-cols-10 gap-6">
          <div class="col-span-1 lg:col-span-7">
            <customer-portal-app-revolution-tyre-molecule [vehicle]="vehicle">
            </customer-portal-app-revolution-tyre-molecule>
            <customer-portal-app-revolution-vehicle-leasing-and-warranty
              [vehicle]="vehicle"
              [vin]="vehicle?.vin"
              >
            </customer-portal-app-revolution-vehicle-leasing-and-warranty>
            <customer-portal-app-revolution-vehicle-service-package-and-insurance
              [vehicle]="vehicle"
              >
            </customer-portal-app-revolution-vehicle-service-package-and-insurance>
            <customer-portal-app-revolution-trade-molecule [vehicle]="vehicle">
            </customer-portal-app-revolution-trade-molecule>
            @if (vehicle && sharedService.showRemindersForVehicle(vehicle)) {
              <customer-portal-app-revolution-vehicle-reminders
                [vehicle]="vehicle"
              ></customer-portal-app-revolution-vehicle-reminders>
            }
          </div>
          <div class="col-span-1 flex flex-col gap-6 lg:col-span-3">
            <customer-portal-app-revolution-vehicle-last-action-service
              [vehicle]="vehicle"
              >
            </customer-portal-app-revolution-vehicle-last-action-service>
            @if (hasVehicleOnlineShop) {
              <customer-portal-app-revolution-vehicle-online-shop-link
                >
              </customer-portal-app-revolution-vehicle-online-shop-link>
            }
            @if (
              hasNearestFuelStation &&

              vehicle?.details?.engine?.fuel?.name &&
              (nearestFuelStationTypes | arrayContains: vehicle?.details?.engine?.fuel?.name)
              ) {
              <customer-portal-app-revolution-nearest-fuel-station [vehicle]="vehicle">
              </customer-portal-app-revolution-nearest-fuel-station>
            }
          

          @if (hasFuelPriceComparison() && fuelPrices?.[0]) {
            <customer-portal-app-fuel-price-comparison
              [vehicle]="vehicle"
              >
            </customer-portal-app-fuel-price-comparison>
          }

          @if (hasFAQ) {
            <customer-portal-app-faq-card
              [alwaysSmall]="true"
            ></customer-portal-app-faq-card>
          }
          </div>  
        </div>
      </div>
    }
    <!-- dealer -->
    <div
      class="content-container"
      id="dealer"
      [hidden]="currentTab !== 'vehicleDealer'"
      >
      <customer-portal-app-revolution-vehicle-dealers
        [setVehicle]="vehicle"
        [setUser]="user"
        >
      </customer-portal-app-revolution-vehicle-dealers>
    </div>
    <!-- details -->
    @if (vehicles?.length) {
      <div
        class="content-container"
        id="vehicle-details"
        [hidden]="currentTab !== 'vehicleDetails'"
        >
        <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div class="col-span-1">
            <customer-portal-app-revolution-vehicle-basic-details
              [setVehicle]="vehicle"
              >
            </customer-portal-app-revolution-vehicle-basic-details>
          </div>
          <div class="col-span-1">
            <customer-portal-app-revolution-vehicle-extended-details>
            </customer-portal-app-revolution-vehicle-extended-details>
          </div>
        </div>
        <customer-portal-app-revolution-vehicle-equipment
          [loading]="dealerLoading"
          >
        </customer-portal-app-revolution-vehicle-equipment>
        <customer-portal-app-revolution-vehicle-energy [loading]="dealerLoading">
        </customer-portal-app-revolution-vehicle-energy>
      </div>
    }
    <!-- vehicle history -->
    <div
      class="content-container"
      id="service"
      [hidden]="currentTab !== 'vehicleServiceHistory'"
      >
      @if (vehicle && vehicle?.vin) {
        <customer-portal-app-revolution-vehicle-documents
          [vehicle]="vehicle"
          >
        </customer-portal-app-revolution-vehicle-documents>
      }
    </div>
    <!-- tracking -->
    @if (vehicles?.length && hasTracking) {
      <div
        class="content-container"
        id="tracking"
        [hidden]="currentTab !== 'vehicleTrackingHistory'"
        >
        @if (vehicle && vehicle?.vin) {
          <customer-portal-app-vehicle-track-trace
            [vehicle]="vehicle"
            >
          </customer-portal-app-vehicle-track-trace>
        }
      </div>
    }
    <div
      class="content-container"
      id="gallery"
      [hidden]="currentTab !== 'vehicleGallery'"
      >
      @if (vehicle && vehicle?.vin) {
        <customer-portal-app-vehicle-images
          [vehicle]="vehicle"
          >
        </customer-portal-app-vehicle-images>
      }
    </div>
  }

  @if (showMobileView === true) {
    <div
      (touchstart)="swipe($event, 'start')"
      (touchend)="swipe($event, 'end')"
      >
      <mat-tab-group
        mat-stretch-tabs="false"
        [(selectedIndex)]="swipeData.currentTab"
        class="mat-tab-group_hide-header"
        >
        <mat-tab>
          <!-- general -->
          @if (vehicles?.length) {
            <div
              class="content-container"
              id="general"
              [hidden]="currentTab !== 'vehicleGeneral'"
              >
              <div class="grid grid-cols-1 lg:grid-cols-10 gap-6">
                <div class="col-span-1 lg:col-span-7">
                  <customer-portal-app-revolution-tyre-molecule
                    [vehicle]="vehicle"
                    >
                  </customer-portal-app-revolution-tyre-molecule>
                  <customer-portal-app-revolution-vehicle-leasing-and-warranty
                    [vehicle]="vehicle"
                    [vin]="vehicle?.vin"
                    >
                  </customer-portal-app-revolution-vehicle-leasing-and-warranty>
                  <customer-portal-app-revolution-vehicle-service-package-and-insurance
                    [vehicle]="vehicle"
                    >
                  </customer-portal-app-revolution-vehicle-service-package-and-insurance>
                  <customer-portal-app-revolution-trade-molecule
                    [vehicle]="vehicle"
                    >
                  </customer-portal-app-revolution-trade-molecule>
                  @if (
                    vehicle && sharedService.showRemindersForVehicle(vehicle)
                    ) {
                    <customer-portal-app-revolution-vehicle-reminders
                      [vehicle]="vehicle"
                    ></customer-portal-app-revolution-vehicle-reminders>
                  }
                </div>
                <div class="col-span-1 flex flex-col gap-6 lg:col-span-3">
                  <customer-portal-app-revolution-vehicle-last-action-service
                    [vehicle]="vehicle"
                    >
                  </customer-portal-app-revolution-vehicle-last-action-service>
                  @if (hasVehicleOnlineShop) {
                    <customer-portal-app-revolution-vehicle-online-shop-link
                      >
                    </customer-portal-app-revolution-vehicle-online-shop-link>
                  }
                  @if (
                    hasNearestFuelStation &&

                    vehicle?.details?.engine?.fuel?.name &&
                    (nearestFuelStationTypes | arrayContains: vehicle?.details?.engine?.fuel?.name)
                    ) {
                    <customer-portal-app-revolution-nearest-fuel-station [vehicle]="vehicle">
                    </customer-portal-app-revolution-nearest-fuel-station>
                  }
                </div>

                @if (hasFuelPriceComparison() && fuelPrices?.[0]) {
                  <customer-portal-app-fuel-price-comparison
                    [vehicle]="vehicle"
                    >
                  </customer-portal-app-fuel-price-comparison>
                }

                @if (hasFAQ) {
                  <customer-portal-app-faq-card
                    [alwaysSmall]="true"
                  ></customer-portal-app-faq-card>
                }

              </div>
            </div>
          }
        </mat-tab>
        <mat-tab>
          <!-- details -->
          @if (vehicles?.length) {
            <div
              class="content-container"
              id="vehicle-details"
              [hidden]="currentTab !== 'vehicleDetails'"
              >
              <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <div class="col-span-1">
                  <customer-portal-app-revolution-vehicle-basic-details
                    [setVehicle]="vehicle"
                    >
                  </customer-portal-app-revolution-vehicle-basic-details>
                </div>
                <div class="col-span-1">
                  <customer-portal-app-revolution-vehicle-extended-details>
                  </customer-portal-app-revolution-vehicle-extended-details>
                </div>
              </div>
              <customer-portal-app-revolution-vehicle-equipment
                [loading]="dealerLoading"
                >
              </customer-portal-app-revolution-vehicle-equipment>
              <customer-portal-app-revolution-vehicle-energy
                [loading]="dealerLoading"
                >
              </customer-portal-app-revolution-vehicle-energy></div
              >
            }</mat-tab>
            <mat-tab
              ><!-- dealer -->
              <div
                class="content-container"
                id="dealer"
                [hidden]="currentTab !== 'vehicleDealer'"
                >
                <customer-portal-app-revolution-vehicle-dealers
                  [setVehicle]="vehicle"
                  [setUser]="user"
                  >
                </customer-portal-app-revolution-vehicle-dealers>
              </div>
            </mat-tab>
            <mat-tab>
              <!-- vehicle history -->
              <div
                class="content-container"
                id="service"
                [hidden]="currentTab !== 'vehicleServiceHistory'"
                >
                @if (vehicle && vehicle?.vin) {
                  <customer-portal-app-revolution-vehicle-documents
                    [vehicle]="vehicle"
                    >
                  </customer-portal-app-revolution-vehicle-documents>
                }
              </div>
            </mat-tab>
            <mat-tab>
              <div
                class="content-container"
                id="gallery"
                [hidden]="currentTab !== 'vehicleGallery'"
                >
                @if (vehicle && vehicle?.vin) {
                  <customer-portal-app-vehicle-images
                    [vehicle]="vehicle"
                    >
                  </customer-portal-app-vehicle-images>
                  }</div
                ></mat-tab>
                @if (
                  hasTracking && vehicle?.createdByDataSource !== 'customer_portal'
                  ) {
                  <mat-tab
                    >
                    <!-- tracking -->
                    @if (vehicles?.length && hasTracking) {
                      <div
                        class="content-container"
                        id="tracking"
                        [hidden]="currentTab !== 'vehicleTrackingHistory'"
                        >
                        @if (vehicle && vehicle?.vin) {
                  <customer-portal-app-vehicle-track-trace
                            [vehicle]="vehicle"
                            >
                          </customer-portal-app-vehicle-track-trace>
                        }
                      </div>
                    }
                  </mat-tab>
                }
              </mat-tab-group>
            </div>
          }
        </div>
